import { Info } from "@mui/icons-material";
import QATableButton from "components/Design/Table/Controls/QATableButton";
import React, { useMemo } from "react";
import QATableButtonRow from "../../components/Design/Table/Layout/QATableButtonRow";
import QATable, { ColumnDefinition } from "../../components/Design/Table/QATable";
import { ExecutionErrorRO, RoleRO } from "../../api/api";
import { DateTime } from "luxon";
import useDialog from "../../components/Hooks/Dialog/useDialog";
import ErrorInfoDialog from "./Dialog/ErrorInfoDialog";

interface Props {
    errors: ExecutionErrorRO[];
    roles: RoleRO[];
}

const ExecutionErrorTable: React.FC<Props> = props => {
    const dialog = useDialog();

    const { errors, roles } = props;

    const columns: ColumnDefinition<ExecutionErrorRO>[] = useMemo(() => [
        {
            id: "role",
            title: "Rolle",
            width: "150px",
            sortable: true,
            getValue: item => `${roles.find(r => r.id === item.roleId)?.name}`
        },
        {
            id: "error",
            title: "Fehler",
            width: "auto",
            sortable: true,
            getValue: item => item.error
        },
        {
            id: "timestamp",
            title: "Zeitpunkt",
            width: "180px",
            sortable: true,
            getValue: item => DateTime.fromISO(item.timestamp).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
        },
        {
            id: "actions",
            width: "40px",
            padding: 0,
            getValue: () => undefined,
            renderCell: item => (
                <QATableButtonRow>
                    <QATableButton
                        icon={Info}
                        onClicked={() => dialog.open(ErrorInfoDialog, {
                            error: item,
                            roles: roles
                        })} />
                </QATableButtonRow>
            )
        }
    ], [dialog, roles]);

    return (
        <>

            <QATable
                defaultSortByColumn="timestamp"
                defaultSortByColumnDesc
                items={errors}
                defaultPageSize={10}
                getId={item => item.id}
                fallbackText="Keine Fehler gefunden."
                columns={columns} />

        </>

    );
};

export default ExecutionErrorTable;
